import React, {useCallback, useEffect, useState} from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

import {forgotPassword, forgotPasswordFailure} from "../../store/main/action";

// ---------------------------------------------------------------------------
// Запрос письма со ссылкой на смену пароля. Ответ сервера всегда одинаковый —
// по нему нельзя узнать, зарегистрирована почта или нет, поэтому и мы
// показываем один и тот же экран «письмо отправлено»
// ---------------------------------------------------------------------------

const ForgotMain = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const started = useSelector(store => store.main.forgotPasswordStarted);
    const err = useSelector(store => store.main.forgotPasswordErr);

    const [email, setEmail] = useState('');
    const [isSent, setIsSent] = useState(false);

    const sendFormHandler = useCallback(()=>{
        if (started || !email.trim().length){
            return;
        }

        dispatch(forgotPassword(email.trim(), ()=>{
            setIsSent(true);
        }));
    }, [email, started, dispatch])

    useEffect(() => {
        const onKeyDown = e => {
            if(e.keyCode === 13) {
                sendFormHandler();
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [sendFormHandler]);

    const emailErr = err?.errors?.email?.[0];
    const commonErr = !err?.errors && (err?.message || '');

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.formWrap}`}>
                    <div className={`${Styles.formTitle}`}>{t('Восстановление пароля')}</div>

                    {isSent ? (
                        <>
                            <div className={`${Styles.doneWrap}`}>
                                <span className={`${Styles.doneMark}`}>✓</span>
                                <span className={`${Styles.doneTitle}`}>{t('Письмо отправлено')}</span>
                            </div>

                            <div className={`${Styles.formNote}`}>
                                {t('Если аккаунт с такой почтой существует, мы отправили на неё ссылку для смены пароля. Ссылка действует час.')}
                            </div>

                            <div className={`${Styles.note}`}>
                                {t('Письма нет?')} <span onClick={()=>{setIsSent(false)}}>{t('Отправить ещё раз')}</span>
                            </div>
                            <div className={`${Styles.tcBtn}`} onClick={()=>{navigate('/sign-in')}}>{t('Вход')}</div>
                        </>
                    ) : (
                        <>
                            <div className={`${Styles.formNote}`}>
                                {t('Укажите почту, на которую зарегистрирован аккаунт — пришлём ссылку для смены пароля.')}
                            </div>

                            <div className={`${Styles.contentBox}`}>
                                <div className={`${Styles.inputWrap} ${emailErr ? Styles.inputWrapWithErr : null}`}>
                                    <div className={`${Styles.inputTitle}`}>{t('Почта')}</div>
                                    <input
                                        className={`${Styles.tcInput}`}
                                        type="text"
                                        placeholder="example@gmail.com"
                                        value={email}
                                        onChange={(e)=>{
                                            setEmail(e.target.value);
                                            if (err){
                                                dispatch(forgotPasswordFailure(false));
                                            }
                                        }}
                                    />
                                    <div className={`${Styles.tcErr} ${emailErr ? Styles.tcErrActive : null}`}>{emailErr || null}</div>
                                </div>
                            </div>

                            <div className={`${Styles.tcErr} ${commonErr ? Styles.tcErrActive : null}`}>{commonErr}</div>

                            <div className={`${Styles.note}`}>
                                {t('Вспомнили пароль?')} <span onClick={()=>{navigate('/sign-in')}}>{t('Вход')}</span>
                            </div>
                            <div
                                className={`${Styles.tcBtn} ${started || !email.trim().length ? Styles.tcBtnDsb : ''}`}
                                onClick={()=>{sendFormHandler()}}
                            >
                                {started ? t('Отправляем…') : t('Отправить ссылку')}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ForgotMain;
